<script setup lang="ts">
import { AppButton } from '@libs/ui';

import { useGlobalSuggestionSwitchStore } from '../../stores/globalSuggestionSwitchStore';

import type { GlobalSuggestionSwitchType } from './globalSuggestionTypeSwitch.model';

const globalSuggestionSwitchStore = useGlobalSuggestionSwitchStore();

function updateSuggestion(suggestionType: GlobalSuggestionSwitchType): void {
  if (globalSuggestionSwitchStore.currentSwitchType !== suggestionType) {
    globalSuggestionSwitchStore.updateSwitchType(suggestionType);
  }
}
</script>

<template>
  <div class="global-suggestion-type-switch">
    <div
      v-if="globalSuggestionSwitchStore.isLoadingPrices"
      class="loader-overlay"
    />
    <AppButton
      v-for="option in globalSuggestionSwitchStore.suggestionOptions"
      :key="option.type"
      :type="option.isSelected ? 'primary' : 'secondary'"
      size="medium"
      state="enabled"
      :no-border="option.isSelected ? false : true"
      @click="updateSuggestion(option.type)"
    >
      <div class="label">
        {{ option.text }}

        <span v-if="option.price" class="price">
          {{ option.price }}
        </span>
      </div>
    </AppButton>
  </div>
</template>

<style scoped lang="scss">
.global-suggestion-type-switch {
  position: relative;
  overflow: hidden;

  margin-right: var(--spacing-24);

  display: flex;
  gap: var(--spacing-8);
  padding: var(--spacing-4);
  background-color: var(--color-white);
  border: 1px solid var(--color-neutral-30);
  border-radius: var(--border-radius-12);

  .loader-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.8;
    background-color: var(--color-neutral-0);
    z-index: 100;
  }

  .label {
    display: flex;
    flex-direction: column;
    align-items: center;

    @include font-label-s-bold;

    .price {
      @include font-label-s-light;
    }
  }
}
</style>
